import type { ButtonHTMLAttributes } from 'react'
import { cx } from './cx.ts'

export type NavButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  direction: 'back' | 'forward'
  label?: string
}

/** Figma: `Nav Button`. Okrągły przycisk wstecz/dalej, 44px (strefa kciuka). */
export function NavButton({
  direction,
  label,
  className,
  type = 'button',
  ...rest
}: NavButtonProps) {
  const aria = label ?? (direction === 'back' ? 'Wstecz' : 'Dalej')
  return (
    <button
      type={type}
      aria-label={aria}
      className={cx(
        'inline-flex size-11 cursor-pointer items-center justify-center rounded-pill bg-bg-card text-text-primary transition-colors hover:text-selected disabled:cursor-default disabled:opacity-40 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-selected',
        className,
      )}
      {...rest}
    >
      <svg
        className={cx('size-5', direction === 'forward' && 'rotate-180')}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 5l-7 7 7 7" />
      </svg>
    </button>
  )
}
